import type { LeadFormStepFields } from "@component/assets/AbstractLeadForm/Steps/BasicLeadForm";
import { BasicLeadForm } from "@component/assets/AbstractLeadForm/Steps/BasicLeadForm";
import { Config } from "@config";
import { FormRadio, ProgressButton, __, getLocale } from "bm-ui-kit";
import type { FormApi } from "final-form";
import type { ReactNode } from "react";
import { Card } from "react-bootstrap";

export const REQUEST_CONSULTANT_CALL_OPTIONS = [
	{
		label: "Szeretnék egy jó nyugdíj megoldást találni",
		value: "Szeretne szerződést",
	},
	{
		label: "Tudni szeretném, van-e jobb a meglévő termékemnél",
		value: "Van meglévő terméke, érdeklődik a váltás iránt",
	},
	{
		label: "Csak nézelődök",
		value: "Csak nézelődik",
	},
];

export interface StepFields {
	requestConsultantCall?: string;
	lastName: string;
	firstName: string;
	email: string;
	phone: string;
	cityName: string;
	cityId?: number;
}

export class LeadForm extends BasicLeadForm {
	public static defaultProps = {
		...BasicLeadForm.defaultProps,
		title: <>Kérd részletes eredményeidet email-ben!</>,
	};

	protected initValues(): StepFields {
		return {
			lastName: undefined,
			firstName: undefined,
			cityName: undefined,
			phone: undefined,
			email: undefined,
			cityId: undefined,
			requestConsultantCall: undefined,
		};
	}

	protected renderContent(
		_values: LeadFormStepFields,
		_form: FormApi<LeadFormStepFields, Partial<LeadFormStepFields>>,
	): ReactNode {
		return (
			<>
				{this.renderHeader()}
				<Card.Body className="bg-white">
					{super.renderFields()}

					{Config.getAbVersion() === "B" && (
						<FormRadio
							label=""
							name="requestConsultantCall"
							options={REQUEST_CONSULTANT_CALL_OPTIONS}
							boldFirstOption
							className="text-dark border rounded p-2"
						/>
					)}
				</Card.Body>
				<Card.Footer className="text-center bg-white">
					{this.renderPrivacyStatement()}
					<ProgressButton
						type="submit"
						variant="primary"
						className="font-weight-bold mt-2"
						block
						disabled={super.isDisabled()}
					>
						Eredmény küldése
					</ProgressButton>
				</Card.Footer>
			</>
		);
	}

	protected renderPrivacyStatement(): ReactNode {
		return (
			<div className="text-dark text-center fs-xs pt-2 mt-auto">
				{__("A lenti gomb megnyomásával elfogadom az")}{" "}
				<a
					className="text-reset text-underline"
					href={Config.getBankmonitorUrl("/adatvedelem/")}
					// biome-ignore lint/a11y/noBlankTarget: in-page link
					target="_blank"
				>
					{__("adatvédelmi tájékoztatóban")}
				</a>
				{getLocale() === "hu_HU" && " foglaltakat."}
			</div>
		);
	}

	renderHeader(): ReactNode {
		const { title, colorVersion } = this.props;

		if (!title) {
			return null;
		}

		return (
			<Card.Header className="bg-primary py-2 h4">
				<div className={`${colorVersion === "white" ? "" : "h4"}  mb-0 text-center`}>{title}</div>
			</Card.Header>
		);
	}

	protected getComponentName(): string {
		return `${super.getComponentName()}.LeadForm`;
	}
}
